/**
 * App-side wiring for `@heidi/ads/data`.
 *
 * Packages are variant-agnostic and store-free: this module injects the app's
 * shared QueryClient so the package's module-scope cache commands hit the SAME
 * cache the app renders from, the reactive auth-token hook (a hook, so gated
 * queries re-evaluate on refresh) and the notifications query the inmail sync
 * reads by reference. Transport is NOT injected here — `data/hcp-verification`
 * reads the `@heidi/api/client` registry, which `scribeHTTP.ts` populates at
 * factory time; the side-effect import below guarantees that ordering.
 * Imported at module scope in `_app.tsx` after the commerce wiring.
 */
// Side-effect: builds the scribe clients AND sets the @heidi/api registry.
import '@/utils/scribeHTTP';

import { useQueryNotifications } from '@/hooks/query/useQueryNotifications';
import { useAuthToken } from '@/hooks/useAuthToken';
import { reactQueryClient } from '@/utils/reactQueryClient';
import { configureAdsData } from '@heidi/ads/data';
import { useQueryUser } from '@heidi/workspace/data';

configureAdsData({
  useAuthToken,
  queryClient: reactQueryClient,
  useQueryNotifications,
  useQueryUser,
});
